import { menuService } from "../services/menu.service";
import router from '@/router'
import { isFulfilled } from "q";

export const menu = {
  namespaced: true,
  state: {
    allMenus: [],
    myMenus:[],
    permission: {}
  },
  getters: {
    menuTree: (state, getters, rootState, rootGetters) => {
      var menuTree = buildMenuTree(state.myMenus, state.permission, rootGetters.selectedLocaleIndex);
      var temp = menuTree;
      for(var i = 0; i < temp.length; i++){
        if(( temp[i].href == null||temp[i].href == "" ) && !temp[i].items)
          temp.splice(i, 1);
          if(temp[i].href == "" && temp[i].items){
            for(var j = temp[i].items.length - 1; j >= 0; j--){
              if(temp[i].items[j].href == "" && !temp[i].items[j].items)
                temp[i].items.splice(j, 1);
            }
          }
      }
      return temp;
    },
    parentMenus: state => {
      return state.allMenus.filter(item => {
        return item.menuType == 1;
      });
    },
    parentMenusDropdown: (state, getters, rootState, rootGetters) => {
      let parentMenus = state.allMenus.filter(item => {
        return item.menuType == 1;
      });
      parentMenus = parentMenus.map(item=>{
        return {text: item['name'+rootGetters.selectedLocaleIndex], value: item.menuId};
      });
      parentMenus.unshift({text: 'None', value: 0});
      return parentMenus;
    },
    childMenus: state => {
      return state.allMenus.filter(item => {
        return item.menuType == 2;
      });
    }
  },
  actions: {
    getMenus({ commit, rootState }) {
      let currentUser = rootState.auth.user;
      return menuService.getPermissionList(currentUser.role).then(data => {
        let rolePermission = data;
        return menuService.getMyMenus().then(menus => {
          menus = menus.filter(menu => {
            return menu.active == 1;
          });
          commit("setMyMenus", menus);
          var permission = convertPermission( rolePermission, menus, currentUser.roleId );
          commit("setPermission", permission);
          //commit("setPermission", rolePermission);

          //
          //check permission after fetch menu
          //
          let accessLevel =  menuService.getAccessLevel(router.currentRoute.path);
          commit("auth/setAccessLevel", accessLevel, { root: true });
        });
      });
    },

    getAllMenus({ commit, rootState }) {
      let currentUser = rootState.auth.user;
      return menuService.getPermissionList(currentUser.role).then(data => {
        let rolePermission = data;
        return menuService.getMenus().then(menus => {
          menus = menus.filter(menu => {
            return menu.active == 1;
          });
          commit("setAllMenus", menus);
          var permission = convertPermission( rolePermission, menus, currentUser.roleId );
          commit("setPermission", permission);
          //
          //check permission after fetch menu
          //
          let accessLevel =  menuService.getAccessLevel(router.currentRoute.path);
          commit("auth/setAccessLevel", accessLevel, { root: true });
        });
      });
    },
  },
  mutations: {
    setAllMenus(state, allMenus) {
      state.allMenus = allMenus;
    },
    setMyMenus(state, menus) {
      state.myMenus = menus;
    },
    setPermission(state, permission) {
      state.permission = permission;
    },
  }
};
function isDisplay(menu){
  if(menu.href ==""){
    if( !menu.items)
      return false;
    return true;
  }
  return true;
}
function buildMenuTree(menus, permission, locale){
  //debugger;
  var converted = [];
  var field = "name" + locale;
  var tempMenus = menus.filter(item => {
    return item.link != "#/profile";
  });
  var parentItems = tempMenus.filter(item => {
    return item.parentId == 0 || item.parentId == null;
  });
  parentItems = parentItems.sort(function(a, b){
    return a.ordering > b.ordering ? 1 : -1;
  });
  parentItems.forEach(item => {
    //debugger;
    let menuItem = {
      title: item[field],
      href: item.link,
      icon: item.icon,
    };
    let childList = getChildren(tempMenus, item.menuId, permission, field);
    if (childList.length > 0) {
      menuItem.items = childList;
    }
    if(item.menuType == 1 && (!menuItem.items || menuItem.items.length == 0)){
      return ;
    }
    converted.push(menuItem);
  });
  return converted;
}

function getChildren(menus, parentId, permission, field) {
  let childMenus = menus.filter(item => {
    return item.parentId == parentId && inPermission(item, permission);
  });
  childMenus = childMenus.sort(function(a, b){
    return a.ordering > b.ordering ? 1 : -1;
  });

  let childList = [];
  childMenus.forEach(child => {
    let childItem = {
      title: child[field],
      href: child.link,
      icon: child.icon
    };
    if(child.menuType == 1){//child is section
      var grandChilds = getChildren(menus, child.menuId, permission, field);
      if(grandChilds.length > 0){
        childItem.items = grandChilds;
      }
    }
    childList.push(childItem);
  });
  return childList;
}

function inPermission(menuItem, permission){
  if(menuItem.menuType == 1){
    return true;
  }
  if (permission[menuItem.menuId]) {
    return true;
  }
  return false;
}

function convertPermission(rolePermission, menus, roleId){
  if (roleId == 1) {
    rolePermission = menus;
  }
  var converted = {};
  rolePermission.forEach(item => {
    if (roleId == 1) {
      //admin
      converted[item.menuId] = 2;
    }else{
      converted[item.menuId] = item.accessLevel;
    }
  })
  return converted;
}